module.exports = __webpack_public_path__ + "static/media/crown_c.43070636.png";